import React from 'react';
import gravatar from '../../../assets/images/gravatar.png'
export default function e27Helicap(){
  return(
<div className="post-1538 post type-post status-publish format-standard hentry category-news e27Helicap">
<div className="blog-single-post nosidebar">

  <section className="subpage-banner"></section>

  <div className="container">

    <div className="row">

      <div className="col-sm-12">
        <div className="row">
          <div className="col-sm-2">
                      
            <img src={gravatar} className="author-avatar img-circle img-responsive" alt="Avatar" />            
                                  

          </div>          

          <div className="col-sm-10">

            <h2 className="post-title">Helicap raises US$1.5M seed funding round led by Singapore’s ex-minister of state Teo Ser Luck</h2>
            <div className="row meta-info">
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-clock"></i>2 May 2018</span></div>
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-comments"></i>No Comments</span></div>
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-eye"></i>104 Views</span></div>
                            <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-tag"></i><a href="/news/" rel="category tag">News</a></span></div>
                          </div>

            <div className="post-article"><p>Read more at https://e27.co/helicap-raises-us1-5m-seed-funding-round-led-by-ex-minister-20180502/</p>
<p>Helicap offers a proprietary platform that raises capital and utilises big data to analyse potential investments for institutional investors, family offices, and high-networth individuals, allowing them to make “superior and consistent” investment returns via alternative channels such as microfinance institutions, small- and medium-sized enterprises (SMEs), and peer-to-peer (P2P) crowdfunding platforms.</p>
</div>

            <hr></hr>
            
            <div className="social-share">
              <div className="row">
                <div className="col-xs-6 share-text">Share</div>
                <div className="col-xs-6 share-button">
                  <div className="btn-group">
                    <a href="https://www.facebook.com/sharer/sharer.php?u=https://33-capital.com/helicap-raises-us1-5m-seed-funding-round-led-by-singapores-ex-minister-of-state-teo-ser-luck/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-facebook"></i></a>
                    <a href="https://plus.google.com/share?url=https://33-capital.com/helicap-raises-us1-5m-seed-funding-round-led-by-singapores-ex-minister-of-state-teo-ser-luck/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-gplus"></i></a>
                    <a href="https://twitter.com/intent/tweet?text=Helicap raises US$1.5M seed funding round led by Singapore’s ex-minister of state Teo Ser Luck&amp;url=https://33-capital.com/helicap-raises-us1-5m-seed-funding-round-led-by-singapores-ex-minister-of-state-teo-ser-luck/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-twitter"></i></a>
                    <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https://33-capital.com/helicap-raises-us1-5m-seed-funding-round-led-by-singapores-ex-minister-of-state-teo-ser-luck/&amp;title=Helicap raises US$1.5M seed funding round led by Singapore’s ex-minister of state Teo Ser Luck&amp;summary=Read more at https://e27.co/helicap-raises-us1-5m-seed-funding-round-led-by-ex-minister-20180502/ Helicap offers a proprietary platform that raises capital and utilises big data to analyse potential investments for institutional investors, family offices, and high-networth individuals, allowing them to make “superior and consistent” investment returns via alternative channels such as microfinance institutions, small- and medium-sized enterprises (SMEs), and peer-to-peer (P2P) crowdfunding platforms.&amp;source=https://33-capital.com/helicap-raises-us1-5m-seed-funding-round-led-by-singapores-ex-minister-of-state-teo-ser-luck/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-linkedin"></i></a>
                    <a href="https://pinterest.com/pin/create/button/?url=https://33-capital.com/helicap-raises-us1-5m-seed-funding-round-led-by-singapores-ex-minister-of-state-teo-ser-luck/&amp;description=Read more at https://e27.co/helicap-raises-us1-5m-seed-funding-round-led-by-ex-minister-20180502/ Helicap offers a proprietary platform that raises capital and utilises big data to analyse potential investments for institutional investors, family offices, and high-networth individuals, allowing them to make “superior and consistent” investment returns via alternative channels such as microfinance institutions, small- and medium-sized enterprises (SMEs), and peer-to-peer (P2P) crowdfunding platforms.&amp;media=" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-pinterest"></i></a>
                  </div>                  
                </div>
              </div>
            </div>  
            <hr></hr>
                        <div className="comment-count">
              No Comments           </div>
            <hr></hr>
                        
          </div>
        
        </div>
      
      </div>

  

    </div>

  </div>

</div>
</div>

  )
}



// WEBPACK FOOTER //
// ./src/components/News/posts/e27_helicap.js